import { render, staticRenderFns } from "./addCustom.vue?vue&type=template&id=3683e4fc&"
import script from "./addCustom.vue?vue&type=script&lang=ts&"
export * from "./addCustom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports